import { stringify } from 'query-string';

import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'PASSWORD_RESET_TOKEN_GET_ALL',
  GET_ALL_SUCCESS: 'PASSWORD_RESET_TOKEN_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'PASSWORD_RESET_TOKEN_GET_ALL_FAILURE',
  POST: 'PASSWORD_RESET_TOKEN_POST',
  POST_SUCCESS: 'PASSWORD_RESET_TOKEN_POST_SUCCESS',
  POST_FAILURE: 'PASSWORD_RESET_TOKEN_POST_FAILURE',
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/password-reset-token/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_URL}/password-reset-token/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
